<template>
	<div class="card">
		<div class="card-header" v-html="Translate('@_PROFILE')"></div>
		<div class="card-body text-left">
			<form>
				<fieldset disabled>
					<div class="form-row">
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="firstname" v-html="Translate('@_FIRST_NAME')"></label>
								<input type="text" id="firstname" class="form-control" v-bind:value="user.firstname" />
							</div>
						</div>
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="lastname" v-html="Translate('@_LAST_NAME')"></label>
								<input type="text" id="lastname" class="form-control" v-bind:value="user.lastname" />
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="gender" v-html="Translate('@_FATHERS_NAME')"></label>
								<input type="text" id="fathersname" class="form-control" v-bind:value="user.parentname" />
							</div>
						</div>
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="kind" v-html="Translate('@_KIND')"></label>								
								<input v-if="user.kind !=2" type="text" id="kind" class="form-control" v-bind:value="Translate('@_USER_TYPE_' + user.kind)" />
								<input v-if="user.remote_id ==1" type="text" id="kind" class="form-control" value="Προπτυχιακός Φοιτητής" />
								<input v-if="user.remote_id ==2" type="text" id="kind" class="form-control" value="Προπτυχιακός Φοιτητής" />
								<input v-if="user.remote_id ==3" type="text" id="kind" class="form-control" value="Προπτυχιακός Φοιτητής " />
								<input v-if="user.remote_id ==4" type="text" id="kind" class="form-control" value="Μεταπτυχιακός Φοιτητής - Ευφυείς Τεχνολογίες Διαδικτύου" />
								<input v-if="user.remote_id ==5" type="text" id="kind" class="form-control" value="Μεταπτυχιακός Φοιτητής - Εφαρμοσμένα Ηλεκτρονικά Συστήματα" />
								<input v-if="user.remote_id ==6" type="text" id="kind" class="form-control" value="PhD Φοιτητής" />
								
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="col-12">
							<div class="form-group">
								<label for="email" v-html="Translate('@_EMAIL')"></label>
								<input type="text" id="email" class="form-control" v-bind:value="user.email" />
							</div>
						</div>
					</div>
				</fieldset>
				<fieldset>
					<div class="form-row">
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="lang" v-html="Translate('@_LANGUAGE')"></label>
								<select class="custom-select my-1 mr-sm-2" id="lang" v-model="lang">
									<option value="el" v-html="Translate('@_GREEK')"></option>
									<option value="en" v-html="Translate('@_ENGLISH')"></option>
								</select>
							</div>
						</div>
						<div class="col-md-6 mb-3">
							<div class="form-group">
								<label for="theme" v-html="Translate('@_THEME')"></label>
								<select class="custom-select my-1 mr-sm-2" id="theme" v-model="theme">
									<option value="light" v-html="Translate('@_LIGHT')"></option>
									<option value="dark" v-html="Translate('@_DARK')"></option>
								</select>
							</div>
						</div>
					</div>
				</fieldset>
			</form>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
	name: "Profile",
	mixins: [Mixin],
	computed: {
		lang: {
			get() {
				return this.user.lang;
			},
			set(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.$store
						.dispatch("http_update_lang", {
							lang: String(newValue)
								.trim()
								.toLowerCase()
						})
						.catch(e => {
							console.error(e);
						});
				}
			}
		},
		theme: {
			get() {
				return this.user.theme;
			},
			set(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.$store
						.dispatch("http_update_theme", {
							theme: String(newValue)
								.trim()
								.toLowerCase()
						})
						.catch(e => {
							console.error(e);
						});
				}
			}
		}
	}
};
</script>

<style scoped></style>
